import { Separator } from '@carboncopyco/ui';
import { Fragment } from 'react';

export interface AssetTableSkeletonProps {
  rows?: number;
}

export const AssetTableSkeleton = ({ rows = 3 }: AssetTableSkeletonProps) => {
  return (
    <div className="flex flex-col px-6">
      {Array.from(Array(rows)).map((_, index) => (
        <Fragment key={index}>
          <div className="flex items-center animate-pulse py-6">
            <div className="flex-auto flex items-center gap-4">
              <div className="bg-ds-natural-150 w-7 h-5 rounded-sm" />
              <div className="w-ds-15 bg-ds-natural-150 rounded-sm h-2" />
            </div>
          </div>
          <Separator horizontal />
        </Fragment>
      ))}
    </div>
  );
};
